import { defineStore } from 'pinia'
import { readonly, ref } from 'vue'

export interface iBaseNotif {
  id: number
  tag_name: string
}

export const baseNotifStore = defineStore('baseNotification', () => {
  const showErrorNotif = ref<boolean>(false)
  const showSuccessNotif = ref<boolean>(false)
  const label = ref<string>('')
  const title = ref<string>('')
  // const masterResearchList = ref<iBaseNotif[]>([])
  // const selectOptions = ref<{ id: number; value: number | string; label: string }[]>()

  const getNotifLabel = readonly(label)
  const getNotifTitle = readonly(title)
  const getErrorNotifState = readonly(showErrorNotif)
  const getSuccessNotifState = readonly(showSuccessNotif)

  function setNotiTitle(text: string) {
    title.value = text
  }
  function setNotiLabel(text: string) {
    label.value = text
  }
  function setErrorNotifState(state: boolean) {
    showErrorNotif.value = state
  }
  function setSuccessNotifState(state: boolean) {
    showSuccessNotif.value = state
  }
  function activateNotif(title: string, label: string, success: boolean = true) {
    setNotiTitle(title)
    setNotiLabel(label)
    setSuccessNotifState(false)
    setErrorNotifState(false)
    if (success) {
      setSuccessNotifState(true)
      setTimeout(() => setSuccessNotifState(false), 4000)
    } else {
      setErrorNotifState(true)
      setTimeout(() => setErrorNotifState(false), 4000)
    }
  }

  return {
    getNotifLabel,
    getNotifTitle,
    getErrorNotifState,
    getSuccessNotifState,
    setNotiLabel,
    setNotiTitle,
    setErrorNotifState,
    setSuccessNotifState,
    activateNotif
  }
})
